/*
 * @Description:
 * @Author: zhanjunwei
 * @Date: 2024-12-04 18:51:32
 * @LastEditors: zhanjunwei
 * @LastEditTime: 2025-03-25 10:23:25
 */
import { ClientApi } from './useClientApi';
import type { ResultTypes } from './type';
import API from './apiUrlCommon';

// 用户信息
export const getClientUserInfoApi = async () => {
  const payload = {
    isOnlyValidateReq: true,
    errorMessage: false,
    cache: 'no-store' as const,
  };
  const data: ResultTypes.ResultUserInfoProps = await ClientApi.get(
    API.userinfoApi,
    payload
  );
  return data;
};

// 退出登录
export const logoutApi = async () => {
  const data = await ClientApi.delete(API.logoutApi, {
    acceptUnauthorized: true,
    errorMessage: false,
  });
  return data;
};

// 获取省市区
export const getDistrictData = async () => {
  const { data }: ResultTypes.DistrictProps = await ClientApi.get(
    API.getDistrictApi
  );
  return data;
};

// 验证是否申领
export const getClientApplyCheckStatus = async (params: {
  productId: string;
  type: number;
}) => {
  const data = await ClientApi.post(API.getApplyCheckApi, params);

  return data;
};

/** 确保文件名后缀为小写（如 .PNG → .png） */
const normalizeExt = (fileName: string): string => {
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex === -1 || dotIndex === 0) return fileName;
  return fileName.slice(0, dotIndex) + fileName.slice(dotIndex).toLowerCase();
};

export const postUploadFile = async (params: any) => {
  // 统一将 filename 参数后缀转为小写，确保 /opentechapi/portal/generateUrl 接收到的扩展名一致
  const filename = params.get?.('filename');
  if (filename) {
    params.set('filename', normalizeExt(filename));
  }

  const uploadFileApi = '/opentechapi/portal/generateUrl';
  const res = await ClientApi.post(
    uploadFileApi,
    {},
    {
      body: params,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-cos-server-side-encryption': 'AES256',
      },
    }
  );
  return res;
};

const uploadContentTypes: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  mp4: 'video/mp4',
  mp3: 'video/mp3',
  webm: 'video/webm',
  ogg: 'video/ogg',
  mpeg: 'video/mpeg',
  wmv: 'video/x-ms-wmv',
  mov: 'video/quicktime',
  flv: 'video/x-flv',
  txt: 'text/plain',
  csv: 'text/csv',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pdf: 'application/pdf',
  zip: 'application/zip',
  rar: 'application/vnd.rar',
  tar: 'application/x-tar',
  gz: 'application/gzip',
};

export const getUploadContentType = (filename: string) => {
  const extension = filename.split('.').pop()?.toLowerCase() ?? '';
  return uploadContentTypes[extension] ?? 'application/octet-stream';
};

export const putFileUrl = async (
  url: string,
  params: any,
  contentType = 'application/octet-stream'
) => {
  const res = await ClientApi.put<{ status: number }>(
    url,
    {},
    {
      body: params,
      noRedirect: true,
      credentials: 'omit',
      headers: {
        'Content-Type': contentType,
        'x-cos-acl': 'private',
      },
    }
  );
  return res;
};

export const getPreviewUrls = async (params: any) => {
  const getPreviewImageApi = '/opentechapi/portal/private/urls';
  const res = await ClientApi.post(getPreviewImageApi, params);
  return res;
};

// 海外版上传文件
export const postUploadFileEn = async (params: any) => {
  const filename = params.get?.('filename');
  if (filename) {
    params.set('filename', normalizeExt(filename));
  }

  const uploadFileApi = '/portalWebAPI/oversea/getPresignedURL';
  const res = await ClientApi.post(
    uploadFileApi,
    {},
    {
      body: params,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-cos-server-side-encryption': 'AES256',
      },
      noRedirect: true,
    }
  );
  return res;
};

// 海外版获取预览URL
export const getPreviewUrlsEn = async (params: any) => {
  const getPreviewImageApi = '/portalWebAPI/oversea/private/urls';
  const res = await ClientApi.post(getPreviewImageApi, params, {
    noRedirect: true,
  });
  return res;
};

export { ResultTypes };
